import { Severity } from '../../../../common/enums/Severity';

export class IssueStatistics {
  constructor(
    private readonly numberOfHigh: number,
    private readonly numberOfMed: number,
    private readonly numberOfLow: number,
    private readonly numberOfNoWarning: number
  ) {}

  getNumberOfHigh() {
    return this.numberOfHigh;
  }

  getNumberOfMed() {
    return this.numberOfMed;
  }

  getNumberOfLow() {
    return this.numberOfLow;
  }

  getNumberOfNoWarning() {
    return this.numberOfNoWarning;
  }

  hasAny(severities: Map<Severity, boolean>) {
    const values = [
      { severity: Severity.HIGH, value: this.numberOfHigh },
      { severity: Severity.MED, value: this.numberOfMed },
      { severity: Severity.LOW, value: this.numberOfLow },
      { severity: Severity.NO_WARNING, value: this.numberOfNoWarning },
    ];

    const sumOfActiveElements = values.reduce((sum: number, { severity, value }) => sum + (severities.get(severity) ? value : 0), 0);

    return sumOfActiveElements > 0;
  }
}
